import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';

export const overquota256TariffId = getFeature('overquota-pre-banner-tariff-id') || 'W256G1m_single_quota_2022_cloud';

// CLOUDWEB-19124
// Показ растяжки для бывших оверквотников
export const preOverquotaBanner: boolean | undefined = isFeature('overquota-pre-banner');

export const preQuotaOfferLimit: number = getFeature('overquota-pre-limit') || 90;
